import { createContext, useContext } from 'react'
import type { RealtimeConnectionStatus } from './useRealtimeSync'

export interface RealtimeStatusContextValue {
  status: RealtimeConnectionStatus
  /** Whether the Realtime channel is connected */
  isLive: boolean
  /** Whether the Realtime channel is reconnecting after an error */
  isReconnecting: boolean
}

export const RealtimeStatusContext = createContext<RealtimeStatusContextValue>({
  status: 'disconnected',
  isLive: false,
  isReconnecting: false,
})

/**
 * Read the current Supabase Realtime connection status.
 * Must be used within a RealtimeStatusProvider (mounted in AppLayout).
 */
export function useRealtimeStatus(): RealtimeStatusContextValue {
  return useContext(RealtimeStatusContext)
}
